var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 28C34.0609 28 26 34.4762 26 42.4762C26 50.4762 34.0609 56.9524 44 56.9524C45.5652 56.9524 47.2087 56.8 48.7739 56.419L57.7739 59.9238C57.8522 59.9238 57.9304 60 58.087 60C58.2435 60 58.4 59.9238 58.5565 59.8476C58.7913 59.6952 58.8696 59.3905 58.8696 59.1619L58.0087 51.5429C60.5913 49.0286 62 45.7524 62 42.4762C62 34.4762 53.9391 28 44 28Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.04e0b6e60855d3b445468dd2b89d8247.svg";
export { ForwardRef as ReactComponent };